export function setupRailTheme() {
    // Password reveal toggle
    document.querySelector(".reveal")?.addEventListener('click', function () {
        let pwd = document.querySelector(".pwd");
        if (pwd.getAttribute('type') === 'password') {
            pwd.setAttribute('type', 'text');
            this.innerHTML = '<i class="bi bi-eye-fill"></i>';
        } else {
            pwd.setAttribute('type', 'password');
            this.innerHTML = '<i class="bi bi-eye-slash-fill"></i>';
        }
    });

    // Industry sector change handler
    const industrySectorElements = document.querySelectorAll('[data-industry-sector]');
    const otherIndustrySectorElements = document.querySelectorAll('[data-other-industry-sector]');

    industrySectorElements.forEach(element => {
        element.addEventListener('change', function() {
            const shouldShow = ['PrivateSectorOther', 'PublicSectorOther', '15', '25'].includes(this.value);

            otherIndustrySectorElements.forEach(otherElement => {
                if (shouldShow) {
                    otherElement.classList.remove('d-none');
                } else {
                    otherElement.classList.add('d-none');
                }
            });
        });
    });

    // Job function change handler
    const jobFunctionElement = document.getElementById('Input_JobFunction');
    const otherJobFunctionElements = document.querySelectorAll('[data-other-job-function]');

    if (jobFunctionElement) {
        jobFunctionElement.addEventListener('change', function() {
            const shouldShow = ['Other', '18'].includes(this.value);

            otherJobFunctionElements.forEach(otherElement => {
                if (shouldShow) {
                    otherElement.classList.remove('d-none');
                } else {
                    otherElement.classList.add('d-none');
                }
            });
        });
    }
}